export const homeObjOne6 = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDes: true,
    topLine: 'Prestige Event & Catering ',
    headline: 'Dekoration & Eventdesign',
    description: 'På Prestige Catering Event förvandlar vi era idéer till unika och minnesvärda miljöer. Vi erbjuder skräddarsydd dekor och eventdesign för bröllop, företagsevent och privata tillställningar. Oavsett om ni vill hyra dekor och skapa själva eller låta vårt team ta hand om hela upplägget, hjälper vi er från idé till färdigt resultat. Vårt mål är att skapa den perfekta känslan och den där extra WOW-effekten som gör ert event oförglömligt.',
    imgStart: false,
    img: require('../../AssetsForDecore/inredning.jpg'),
    alt: 'catering',
    dark: true,
    primary: true,
    darkText: false,
}